import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { TbPlane, TbReceipt } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../Hooks/useFetch";
import apis from "../../../../Utils/apis";

const emptyGroup = {
	approvalsToday: 0,
	totalPendingApprovals: 0,
	readyToBook: 0,
	awaitingApproval: 0,
};

function GlanceTile({ value, label, onClick, accent }) {
	const className = accent
		? "flex flex-col h-full p-4 text-left text-white bg-accent rounded-xl"
		: "flex flex-col h-full p-4 text-left border bg-whitish rounded-xl";
	const body = (
		<>
			<div className={`text-4xl font-semibold leading-none ${onClick ? "flex items-start justify-between gap-2" : ""}`}>
				{value}
				{onClick ? (
					<div className="w-8 h-8 text-lg rounded-full bg-surface flex-center shrink-0">
						<FiArrowUpRight />
					</div>
				) : null}
			</div>
			<div className={`mt-2 text-sm leading-snug ${accent ? "text-white" : "text-secondary"}`}>{label}</div>
		</>
	);

	if (!onClick) {
		return <div className={className}>{body}</div>;
	}

	return (
		<button type="button" onClick={onClick} className={`${className} cursor-pointer`}>
			{body}
		</button>
	);
}

function GlanceTabs({ options, selected, onTypeChange, flight, expense }) {
	return (
		<div className="flex items-center gap-3">
			{options.map((option) => {
				const isActive = selected?.value === option.value;
				const count = option.value === "expense" ? expense.approvalsToday : flight.approvalsToday;
				return (
					<button
						key={option.value}
						type="button"
						onClick={() => onTypeChange(option)}
						className={`flex items-center gap-2.5 px-4 py-2 text-base border rounded-xl ${isActive ? "bg-light border-surface text-dark" : "bg-canvas border-muted text-dark hover:bg-light"}`}
					>
						{option.value === "expense" ? <TbReceipt className="text-xl" /> : <TbPlane className="text-xl" />}
						{option.label}
						<span className={`inline-flex items-center justify-center min-w-[1.5rem] h-6 px-1.5 text-sm font-medium leading-none rounded-full ${isActive ? "bg-surface text-strong" : "bg-danger text-dangerText"}`}>
							{count}
						</span>
					</button>
				);
			})}
		</div>
	);
}

function AtAGlance({ type = "flight", options = [], selected, onTypeChange = () => {} }) {
	const navigate = useNavigate();
	const { response } = useFetch(apis.atAGlanceCount, null, {
		count: {
			flight: emptyGroup,
			expense: { approvalsToday: 0, totalPendingApprovals: 0, awaitingApproval: 0 },
		},
	});

	const flight = response.count?.flight || emptyGroup;
	const expense = response.count?.expense || emptyGroup;

	return (
		<div className="col-span-2 my-6 rounded-2xl">
			<div className="flex flex-wrap items-center justify-between gap-3">
				<h3 className="!text-base !font-semibold">At a Glance</h3>
				<GlanceTabs options={options} selected={selected} onTypeChange={onTypeChange} flight={flight} expense={expense} />
			</div>
			{type === "expense" ? (
				<div className="grid grid-cols-1 gap-3 mt-4 sm:grid-cols-2 lg:grid-cols-4 text-dark">
					<GlanceTile accent value={expense.approvalsToday} label="Approvals arrived today" />
					<GlanceTile value={expense.awaitingApproval} label="Requested approvals" />
				</div>
			) : (
				<div className="grid grid-cols-1 gap-3 mt-4 sm:grid-cols-2 lg:grid-cols-4 text-dark">
					<GlanceTile accent value={flight.approvalsToday} label="Approvals arrived today" />
					<GlanceTile value={flight.totalPendingApprovals} label="Total pending approvals" onClick={() => navigate("/app/approvals")} />
					<GlanceTile value={flight.readyToBook} label="Approvals ready to book" onClick={() => navigate("/app/bookings?tab=ready")} />
					<GlanceTile value={flight.awaitingApproval} label="Requested approvals" onClick={() => navigate("/app/bookings?tab=requested")} />
				</div>
			)}
		</div>
	);
}

export default AtAGlance;
